import { render } from "./ViewProfesseur.vue?vue&type=template&id=23feb13c&scoped=true&ts=true"
import script from "./ViewProfesseur.vue?vue&type=script&lang=ts"
export * from "./ViewProfesseur.vue?vue&type=script&lang=ts"

import "./ViewProfesseur.vue?vue&type=style&index=0&id=23feb13c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23feb13c"]])

export default __exports__